import {getVisualizationConfigGQLFromStep} from 'analysis-tool/data/StepConfigUtils';
import {
  PARAMETERS_TYPENAME_TO_VISUALIZATION_TYPE,
  VISUALIZATION_TYPE_TO_ICON,
  VISUALIZATION_TYPE_TO_READABLE,
} from 'insights/analytics-visualizations/AnalyticsVisualizationConstants';

import {GetStepNodeContentsFn} from './NodeContentsTypes';

export const getVisualizationStepNodeContentsInfo: GetStepNodeContentsFn = (step) => {
  const {visualizationConfig} = getVisualizationConfigGQLFromStep(step);
  const visualizationType =
    PARAMETERS_TYPENAME_TO_VISUALIZATION_TYPE[visualizationConfig.parameters.__typename];

  return {
    icon: VISUALIZATION_TYPE_TO_ICON[visualizationType],
    title: VISUALIZATION_TYPE_TO_READABLE[visualizationType],
  };
};
